import {Attributes, Card, DataStatus} from 'platform/components';
import {useDateTimeFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {useGetVehicleV2Query} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {testIds, vehiclesRoutes} from '@dms/routes';

import {composePath, parseDate, useNavigate} from 'shared/web';

type Props = {
  vehicleId: string;
  canEditVehicle: boolean;
};

export const TechnicalInspectionCard = ({vehicleId, canEditVehicle}: Props) => {
  const navigate = useNavigate();
  const {data: vehicle, isLoading, isError} = useGetVehicleV2Query({vehicleId});

  const formatDateTime = useDateTimeFormatter();

  const handleOnClick = () =>
    navigate(
      composePath(vehiclesRoutes.editV2Tab, {
        params: {id: vehicleId, tab: 'vehicle-data'},
      })
    );

  return (
    <Card
      title={i18n.t('entity.vehicle.labels.technicalInspection')}
      actions={
        canEditVehicle
          ? [
              {
                variant: 'link',
                type: 'button',
                leftIcon: 'image/edit',
                onClick: handleOnClick,
                'data-testid': testIds.vehicles.vehicleData('technicalInspection-edit'),
                title: i18n.t('general.actions.edit'),
              },
            ]
          : undefined
      }
      data-testid={testIds.vehicles.vehicleData('technicalInspection')}
    >
      <DataStatus isLoading={isLoading} isError={isError}>
        <Attributes
          data-testid={testIds.vehicles.vehicleData('technicalInspection-parameters')}
          rows={[
            {
              label: i18n.t('entity.vehicle.labels.inspectionValidUntil'),
              value:
                vehicle?.technicalInspectionValidUntil &&
                formatDateTime('dateShort', parseDate(vehicle?.technicalInspectionValidUntil)),

              testId: 'inspectionValidUntil',
            },
            {
              label: i18n.t('entity.vehicle.labels.acceptableTechnicalCondition'),
              value: isNil(vehicle?.isAcceptableForTechnicalInspection)
                ? null
                : vehicle?.isAcceptableForTechnicalInspection
                  ? i18n.t('general.labels.yes')
                  : i18n.t('general.labels.no'),
              testId: 'acceptableTechnicalCondition',
            },
            {
              label: i18n.t('entity.vehicle.labels.technicalInspectionNote'),
              value: vehicle?.technicalInspectionNote,
              testId: 'technicalInspectionNote',
            },
          ]}
        />
      </DataStatus>
    </Card>
  );
};
